import BigNumber from "bignumber.js";
export function serializeSolanaTransaction({ amount, family, model, recipient, }) {
    return {
        amount: amount.toString(),
        family,
        model: JSON.stringify(model),
        recipient,
    };
}
export function deserializeSolanaTransaction({ family, amount, model, recipient, }) {
    return {
        amount: new BigNumber(amount),
        family,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        model: JSON.parse(model),
        recipient,
    };
}
//# sourceMappingURL=serializer.js.map